module.exports = __webpack_public_path__ + "img/qr-code.3d8e3b0d.jpg";